import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';

import {useTranslations} from './useTranslations';

const defaultGuestsTranslations = {
    separatorText: ', ',
    adultText: 'Adult',
    adultsText: 'Adults',
    ageSelectSubtitle: 'This helps us show you a more accurate price',
    ageSelectTitle: 'How old are the children?',
    ageSelectTitleSingular: 'How old is the child?',
    childText: 'Child',
    childrenText: 'Children',
    guestText: 'Guest',
    guestsText: 'Guests',
    petsText: 'Pets',
    label: 'Guests',
    guestLabel: undef,
    modalTitle: 'Select guests',
    adultsLabel: undef,
    childrenLabel: undef,
    petLabel: 'Pets',
    petNoLabel: 'No',
    petYesLabel: 'Yes',
    petMessage: 'Only properties that allow pets will be shown',
    applyButtonLabel: 'Apply',
    clearButtonLabel: 'Clear',
    continueButtonLabel: 'Continue'
};

function useGuestsTranslations(props) {
    const {
        guestsTranslations: propsGuestsTranslations
    } = props;

    const {
        translations: guestsTranslations
    } = useTranslations(defaultGuestsTranslations, propsGuestsTranslations);

    const result = {
        guestsTranslations
    };

    useDebugValue(result);

    return result;
}

export {useGuestsTranslations};
